module.exports = __webpack_public_path__ + "img/60600.68e91d6e.jpg";